import { Chip, Stack, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';

import {
	VIEW_MORE_LABEL,
	GENERATING_RESPONSE_LABEL,
} from 'common/constants/index';

import { IGPTMessageProps, IUploadedDocumnetInfo } from '../api/type-def';

import UploadDocumentDeleteCard from './UploadDocumentDeleteCard';

import styles from './UploadDocumentList.module.scss';

interface IUploadDocumentList {
	listData: IUploadedDocumnetInfo[];
	onDeleteListHandler: (data: IUploadedDocumnetInfo) => void;
	showMore?: boolean;
	messages?: IGPTMessageProps[];
}

const UploadDocumentList = (props: IUploadDocumentList) => {
	const { listData, onDeleteListHandler, showMore = false } = props;

	const getVisibleItemCount = () => {
		const screenWidth = window.innerWidth;
		if (screenWidth >= 1024) {
			return 3;
		} else if (screenWidth >= 480 && screenWidth < 1024) {
			return 2;
		}
		return 1;
	};
	const [visibleItems, setVisibleItems] = React.useState(getVisibleItemCount());
	const onDeleteHandler = (data: IUploadedDocumnetInfo) => {
		onDeleteListHandler(data);
	};

	const [showAll, setShowAll] = useState(false);

	const handleShowAll = () => {
		setShowAll(!showAll);
	};

	useEffect(() => {
		if (showMore) {
			setShowAll(false);
		}
	}, [showMore]);

	useEffect(() => {
		const handleResize = () => {
			setVisibleItems(getVisibleItemCount());
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	const remainingListData = showAll ? listData.slice(visibleItems) : [];

	return (
		<div
			className={styles['uploaddocuments-list-container']}
			data-testid="upload-doc-list"
		>
			{listData?.length > 0 && (
				<>
					<div
						className={styles['uploaddocuments-generate-container']}
						data-testid="upload-doc-list-file"
					>
						<div className={styles['uploaddocuments-generate-textcontainer']}>
							<Typography
								className={styles['uploaddocument-documents-generatingtext']}
								data-testid="upload-doc-listname"
							>
								{GENERATING_RESPONSE_LABEL}
							</Typography>
						</div>
						{showAll && remainingListData?.length > 0 && (
							<div
								className={styles['uploaddocuments-remaininglist-documents']}
							>
								{remainingListData.map((ele: any) => (
									<UploadDocumentDeleteCard
										key={ele.id}
										fileInfo={ele}
										onDeleteActionHandler={onDeleteHandler}
									/>
								))}
							</div>
						)}
					</div>
					<div
						className={styles['uploaddocuments-visible-documents-container']}
					>
						<div className={styles['uploaddocuments-visible-documents']}>
							{listData.slice(0, visibleItems).map((ele: any) => (
								<UploadDocumentDeleteCard
									key={ele.id}
									fileInfo={ele}
									onDeleteActionHandler={onDeleteHandler}
								/>
							))}
						</div>

						{listData?.length > 3 && (
							<Stack
								className={styles['uploaddocuments-showmore-chipcontainer']}
								data-testid="upload-doc-showmore-btn"
								onClick={handleShowAll}
							>
								<Typography
									className={styles['uploaddocuments-showmore-label']}
								>
									{VIEW_MORE_LABEL}
								</Typography>
								<Chip
									color="error"
									className={styles['uploaddocuments-showmore-chipicon']}
									label={(listData?.length ?? 0) - (visibleItems ?? 0)}
									size="medium"
								/>
							</Stack>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default UploadDocumentList;
